import "@hotwired/turbo-rails";

// Disable Turbo's form handling by default.
// Use data-turbo="true" to enable turbo on individual forms.
Turbo.setFormMode("optin");

// Custom action so the controller can trigger a Swal from a turbo-stream response without replacing DOM.
Turbo.StreamActions.employee_ids_delete_swal = function () {
  const icon = this.getAttribute('icon');

  Swal.fire({
    title: this.getAttribute('title'),
    text: this.getAttribute('message'),
    icon: icon
  }).then(function () {
    // NOTE: Settings and Users are Bootstrap tabs on the same page (e.g. /admin/companies/recognizeapp.com),
    // so the already-rendered Users datatable still shows stale employee IDs until reloaded.
    if (icon === 'success') {
      R.LitaTables['users_admin']?.dataTable.ajax.reload();
    }
  });
};
